import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;

  ${({ theme }) => `
    background: ${theme.color.haze};
    padding: ${theme.space.mobile.nano} ${theme.space.mobile.base};
    border-radius: 40px;
  `}

  ${({ theme }) => media.sm`
    padding: ${theme.space.desktop.nano} ${theme.space.desktop.base};
  `}
`
